
import { API_URL as ENDPOINT } from "../config/env";

export async function PresupuestosGet(id, token) {
    return fetch(`${ENDPOINT}presupuestos/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
        },
        method: 'get',
        cache: 'no-store',
    }).then(res => res.json()).then(response => {
        return response;
    });
}

export async function PresupuestosPadreUpdate(data, token) {
    return fetch(`${ENDPOINT}presupuestosPadreUpdate`, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
            
        },
        method: 'post',
        body: data
    }).then(res => res.json()).then(response => {
        return response;
    });
}

export async function PadresMontoGet(id, token) {
    return fetch(`${ENDPOINT}PadresMonto/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`

        },
        method: 'get',
        cache: 'no-store',
    }).then(res => res.json()).then(response => {
        return response;
    });
}

export async function CuentaDelete(data, token) {
    return fetch(`${ENDPOINT}presupuestosDelete`, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
        },
        method: 'post',
        body: data
    }).then(res => res.json()).then(response => {
        return response;
    });
}

export async function PresupuestosAportacionUpdate(data, token) {
    return fetch(`${ENDPOINT}presupuestosAportacionUpdate`, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
            
        },
        method: 'post',
        body: data
    }).then(res => res.json()).then(response => {
        return response;
    });
}
export async function PresupuestosOrden(data, token) {
    return fetch(`${ENDPOINT}presupuestosOrden`, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
        },
        method: 'post',
        body: data
    }).then(res => res.json()).then(response => {
        return response;
    });
}

/**
 * El archivo real (portada, esquema financiero, desglose y flujo de efectivo)
 * lo arma el backend con los mismos números que alimentan la pantalla; antes
 * el botón generaba un Excel aparte en el navegador, con una sola hoja y
 * datos armados a mano que no cuadraban con esos cuatro reportes.
 */
export async function PresupuestoExportar(proyectoId, token) {
    const respuesta = await fetch(`${ENDPOINT}PresupuestoExportar/${proyectoId}`, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
        },
        method: 'get',
    });

    if (!respuesta.ok) {
        const error = await respuesta.json().catch(() => null);
        throw new Error(error?.message || 'No se pudo exportar el presupuesto');
    }

    return respuesta.blob();
}
